module.exports = __webpack_public_path__ + "static/media/CAMARONV_MENU-normal.14837fec.png";